import {MAX_QUERY_LENGTH} from "@/consts";
import {getAddressByString, getFioByString, getIssuedByPassport} from "@/api/routes/calculator-eipoteka";

export const fetchSuggestionsConstructor = (asyncCb) => {
    return async function (queryString, cb) {
        if (!queryString?.length || queryString?.length >= MAX_QUERY_LENGTH) {
            return cb([])
        }
        try {
            const data = await asyncCb(queryString);
            cb(data);
        } catch (err) {
            throw new Error(err)
        }
    }
}

export const fetchAddressSuggestions = () => {
    return fetchSuggestionsConstructor(getAddressByString)
}

export const fetchPassportCodeSuggestions = () => {
    return fetchSuggestionsConstructor(getIssuedByPassport)
}

export const fetchFioSuggestions = () => {
    return fetchSuggestionsConstructor(getFioByString)
}

export const debounce = (func, timeout = 300) => {
    let timer;

    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}